import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import {LOGIN, SIGNUP} from "../src/constants/paths";
import './App.css';
import Login from './Screens/Login';
import RouteResolver from './Screens/App/RouteResolver';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import { AxiosInterceptor } from './network';
import { ThemeProvider} from '@mui/material/styles'
import CustomTheme from "./CustomTheme";
import ApolloClientProvider from './apolloClient';
import { WarehouseProvider } from './contexts/WarehouseContext';
import { DateProvider } from './contexts/DateContext';
import LeadsGeneration from './Screens/SignUp';


function App() {
 
  return (
    
    <div className="App">
      <ApolloClientProvider>
        <ThemeProvider theme={CustomTheme} >
          <AuthProvider>
            <AxiosInterceptor>
            <Router>
              <Routes>
                <Route path = {LOGIN} element= {<Login/>}/>
                <Route path = {SIGNUP} element = {<LeadsGeneration/>}/>
                <Route 
                    path="*" 
                    element={
                      <PrivateRoute>
                        <WarehouseProvider>
                          <DateProvider>
                            <RouteResolver />
                          </DateProvider>
                        </WarehouseProvider>
                      </PrivateRoute>
                    } 
                  />
              </Routes>
            </Router>
            </AxiosInterceptor>
          </AuthProvider>
        </ThemeProvider>
      </ApolloClientProvider>
    </div>

  );
}

export default App;
